import {
  Component,
  HostListener,
  Input,
  OnInit,
  OnDestroy,
} from '@angular/core';
import {
  LangChangeEvent,
  TranslateService,
  TranslateModule,
} from '@ngx-translate/core';

import { OwlOptions, CarouselModule } from 'ngx-owl-carousel-o';
import { Subscription } from 'rxjs';
import { remarkInterface } from 'src/app/configs/usersComments';
import { TruncatePipe } from '../../../../../pipe/truncate.pipe';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'app-carr2-img',
  templateUrl: './carr2-img.component.html',
  styleUrls: ['./carr2-img.component.scss'],
  standalone: true,
  imports: [CarouselModule, NgStyle, TranslateModule, TruncatePipe],
})
export class Carr2ImgComponent implements OnInit, OnDestroy {
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkWidth(event.target.innerWidth);
  }

  @Input() data: Array<remarkInterface>;

  truncateValue = null;

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: false,
    navSpeed: 1100,
    autoplaySpeed: 800,
    autoplayTimeout: 2000,
    autoWidth: true,
    autoplay: true,
    autoplayHoverPause: true,
    autoplayMouseleaveTimeout: 100,
    responsive: {
      0: {
        items: 1,
      },
      380: {
        items: 2,
      },
      575: {
        items: 3,
      },
      876: {
        items: 4,
      },
      1176: {
        items: 5,
      },
    },
    nav: false,
  };

  currentLang: string = this.translate.defaultLang;
  languageSelected: string = this.currentLang.split('-')[1];
  subscription: Subscription;

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.checkWidth(window.innerWidth);
    this.subscription = this.translate.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.currentLang = event.lang;
        this.languageSelected = this.currentLang.split('-')[1];
      }
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  checkWidth(windowWidth: number): void {
    if (windowWidth < 400) {
      this.truncateValue = 100;
    } else if (windowWidth > 400 && windowWidth < 600) {
      this.truncateValue = 55;
    } else if (windowWidth > 600 && windowWidth < 900) {
      this.truncateValue = 60;
    } else if (windowWidth > 900 && windowWidth < 1200) {
      this.truncateValue = 70;
    } else if (windowWidth > 1200 && windowWidth < 1500) {
      this.truncateValue = 130;
    } else if (windowWidth > 1500 && windowWidth < 1700) {
      this.truncateValue = 200;
    } else {
      this.truncateValue = null;
    }
  }
}
